module.exports = __webpack_public_path__ + "static/media/certificate_signature.15e4ddb5.png";